export const QUICKTEST_URL = '/ipm/v1/admin/quicktests/:_id';

export const QUICK_TEST_STATUS = {
    INITIALIZING: 'Initializing', // initializing
    SETTING_UP: 'Setting Up', // setting up
    RUNNING: 'Running', // running
    TEARING_DOWN: 'Tearing Down', // tearing down
    COMPLETE: 'Complete', // complete
    ERROR: 'Error', // error
    CANCELED: 'Canceled', // canceled
};

export const QUICK_TEST_AGENT_RESULTS_STATUS = {
    INITIALIZING: 'I', // initializing
    SETTING_UP: 'S', // setting up
    QUEUED: 'Q', // waiting in executor que
    RUNNING: 'R', // running
    TEARING_DOWN: 'T', // tearing down
    COMPLETE: 'C', // complete
    ERROR: 'E', // error
    CANCELED: 'X', // canceled
};

export const QUICK_TEST_TYPE = {
    ADVANCED: 'advanced',
    URL: 'url',
    EXISTING: 'existing',
    VOIP_PULSE_TO_PULSE: 'VoipPulse',
    VOIP_PULSE_TO_PHONE: 'VoipPhone',
    VOIP_DIAL: 'VoipDial',
    OTHER: 'other',
};

export const VOIP_QUICK_TEST_PARTY_STATUSES = {
    INITIALIZING: 'I',
    CONFIGURED: 'O',
    QUEUED: 'Q',
    WAITING: 'W',
    PLACING_CALL: 'P',
    CALL_ACCEPTED: 'A',
    RUNNING: 'R',
    TEARDOWN: 'T',
    HANGUP: 'H',
    ENDED: 'F',
    COMPLETED: 'C',
    ERROR: 'E',
    UNANSWERED: 'U',
    UNREGISTERED: 'D',
    TERMINATED: 'M',
    'UNEXPECTED HANGUP': 'G',
    UNABLE_TO_PLACE_THE_CALL: 'L',
    UNABLE_TO_RECEIVE_THE_CALL: 'V',
    EXPIRED_TIMEOUT_REACHED: 'B',
    CANCELED_THE_CALL_WAS_CANCELED: 'X',
    PHONE: 'N',
    REGISTER_WAV_FAILURE: 'Z',
};

export const VOIP_COLORS = {
    green: '#1e7811',
    yellow: '#FAAC3F',
    red: '#C22C1E',
};
